module.exports = __webpack_public_path__ + "img/assure.1be5fc69.png";